import { __toESM as e } from "../../_virtual/_rolldown/runtime.mjs";
import { ToolbarPopover as t } from "../content-controls/toolbar-popover.mjs";
import { require_lodash_debounce as n } from "../../node_modules/lodash.debounce/index.mjs";
import { useEffect as r, useMemo as i, useRef as a, useState as o } from "react";
import { Button as s } from "@systemeio/components";
import { jsx as c, jsxs as l } from "react/jsx-runtime";
import { HexAlphaColorPicker as u, HexColorInput as d, HexColorPicker as f } from "react-colorful";
//#region src/components/color-picker/index.tsx
var p = /* @__PURE__ */ e(n());
function m({ applyLabel: e, asSheetRow: n = !1, children: m, clearDisabled: h, clearLabel: g, color: _, disabled: v, label: y, onApply: b, onClear: x, onPreview: S, showAlpha: C = !0, showTooltip: w = !0 }) {
	let [T, E] = o(_), [D, O] = o(!1), k = a(S);
	k.current = S;
	let A = i(() => (0, p.default)((e) => k.current(e), 300), []);
	r(() => () => A.cancel(), [A]);
	let j = (e) => {
		E(e), A(e);
	}, M = C ? u : f;
	return r(() => E(_), [_]), /* @__PURE__ */ c(t, {
		asSheetRow: n,
		disabled: v,
		icon: m,
		keepEditorFocus: !0,
		label: y,
		onOpenChange: (e) => {
			e || A.flush(), O(e);
		},
		open: D,
		popupClassName: "w-56 p-3",
		tooltip: w ? y : null,
		children: /* @__PURE__ */ l("div", {
			className: "flex flex-col gap-3",
			children: [
				/* @__PURE__ */ c(M, {
					color: T,
					onChange: j
				}),
				/* @__PURE__ */ l("div", {
					className: "border-field-border flex h-8 overflow-hidden rounded-md border",
					children: [/* @__PURE__ */ c("span", {
						className: "bg-bg-secondary text-text-secondary flex items-center px-2",
						children: "#"
					}), /* @__PURE__ */ c(d, {
						alpha: C,
						"aria-label": y,
						className: "text-text-primary min-w-0 flex-1 px-2 outline-none",
						color: T,
						onChange: j
					})]
				}),
				/* @__PURE__ */ l("div", {
					className: "flex gap-2",
					children: [/* @__PURE__ */ c(s, {
						className: "flex-1",
						disabled: h,
						onClick: () => {
							A.cancel(), x(), O(!1);
						},
						size: "sm",
						variant: "destructive-ghost",
						children: g
					}), /* @__PURE__ */ c(s, {
						className: "flex-1",
						onClick: () => {
							A.cancel(), b(T), O(!1);
						},
						size: "sm",
						children: e
					})]
				})
			]
		})
	});
}
//#endregion
export { m as ColorPicker };
